import { Fragment } from 'react'
import { ScaleLinear } from 'd3'
import { formatSwissDate } from './formatSwissDate'

export const Tooltip = ({
  data,
  locale,
  y,
}: {
  data: ttDataType
  locale: 'de' | 'fr'
  y: ScaleLinear<number, number>
}) => {
  const textOffsetY = 17
  let textYValues = data.data
    .map((m) => Math.min(y.range()[0] + y.range()[1] - y(m.v), y.range()[0]))
    .sort((a, b) => a - b)

  textYValues = textYValues.map((m, i) => {
    if (textYValues[i + 1]) {
      if (m > textYValues[i + 1] - 13) {
        textYValues[i + 1] = Math.min(m + 13, y.range()[0] - 4)
      }
      if (m > y.range()[0] - 13 && textYValues[i + 1] === y.range()[0] - 4) {
        m = m - 17
      }
    }
    return m
  })

  return (
    <g transform={`translate(${data.pos.x},0)`} className='Tooltip'>
      <line y1={y(Math.max(...data.data.map((m) => m.v)))} y2={y.range()[0]} />
      {data.data
        .sort((a, b) => b.v - a.v)
        .map((m, i) => {
          return (
            <Fragment key={'tt_' + i}>
              <circle className='ttMarker inner' r={3} cy={y(m.v)} />

              <text
                x={data.pos.anchor === 'end' ? -20 : +20}
                y={y(m.v)}
                textAnchor={data.pos.anchor}
              >
                {Math.round(m.v)}{data.suffix}
              </text>
            </Fragment>
          )
        })}
      <text
        y={y.range()[0] + textOffsetY}
        textAnchor={'middle'}
      >
        {formatSwissDate(data.data[0].d, 'extended', locale)}
      </text>
    </g>
  )
}
